import CheckoutMatchingWrapper from './CheckoutMatchingWrapper.component';

export default CheckoutMatchingWrapper;